/*
 * Make sure YouTube video embeds via iframe are responsive.
 */
if (!CSS.supports('aspect-ratio: 16/9')) {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('iframe[src*="youtube.com"]').forEach(iframe => {
      var container = document.createElement('div')
      container.classList.add('youtube-embed')
      iframe.parentNode.insertBefore(container, iframe)
      container.appendChild(iframe)
    })
  })
}
